// extracted by mini-css-extract-plugin
module.exports = {"deleted":"UserText__deleted___sv5fv"};